import {tabContainer} from '@xh/hoist/cmp/tab';
import {hoistCmp, uses, XH} from '@xh/hoist/core';
import {RzxAppModel} from './RzxAppModel';
import {appNavBar} from './cmp/navbar/AppNavBar';
import './styles/rzx.scss';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {tickerTapeBar} from './cmp/tickerTape/TickerTapeBar';
import {hframe} from '@xh/hoist/cmp/layout';
import {sideNavBar} from './cmp/navbar/SideNavBar';
import {aiChatPanel} from './cmp/aiChat/AiChatPanel';

export type NavModeType = 'tabs' | 'sideNavBar';

export const RzxApp = hoistCmp({
    model: uses(RzxAppModel),
    className: 'rzx-app',
    render() {
        const mode = XH.getPref('navMode', 'tabs') as NavModeType;

        return mode === 'tabs'
            ? panel({
                  tbar: appNavBar(),
                  item: hframe(tabContainer({switcher: false, testId: 'rzx-tabs'}), aiChatPanel()),
                  bbar: tickerTapeBar()
              })
            : panel({
                  item: hframe(sideNavBar(), tabContainer({switcher: false, testId: 'rzx-tabs'}), aiChatPanel()),
                  bbar: tickerTapeBar()
              });
    }
});
